import { WidgetLabelStyle } from './WidgetLabelStyle';


/**
 * WidgetLabel component that renders a label for a widget
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.children - The label text to be displayed.
 * @returns {JSX.Element} The rendered WidgetLabel component.
 * 
 * @example
 * return (
 * <WidgetLabel>
 *    {children}
 * </WidgetLabel>
 * )
 * 
 * 
 */
const WidgetLabel = ({ children }, props) => {
    return (
        <WidgetLabelStyle {...props}>
            {children}
        </WidgetLabelStyle>
    );
};

export default WidgetLabel;